// extracted by mini-css-extract-plugin
export default {"iconAnt":"mZJSqDYscBHNGiG3Ciy9","label":"bBuDQAiwINtkwFFm3n7Q","listItem":"TVGN8iYQbn58Wdo9n3IT"};